module.exports = __webpack_public_path__ + "img/teams-grid-edit-icon.cefaff1f.svg";